import(/* webpackMode: "eager" */ "/app/apps/hafizalquran/src/app/[locale]/error.tsx");
